import { useState, useEffect } from 'react';

const breakpoints = {
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
};

const getBreakpoint = () => {
  if (window.matchMedia(breakpoints.xl).matches) return 'xl';
  if (window.matchMedia(breakpoints.lg).matches) return 'lg';
  if (window.matchMedia(breakpoints.md).matches) return 'md';
  if (window.matchMedia(breakpoints.sm).matches) return 'sm';
  return 'xs';
};

const useBreakpoints = () => {
  const [currentBreakpoint, setCurrentBreakpoint] = useState(getBreakpoint());

  useEffect(() => {
    const handleResize = () => {
      setCurrentBreakpoint(getBreakpoint());
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return currentBreakpoint;
};

export default useBreakpoints;